<template>
  <div class="ui-file-item">
    <div class="upload-img">
      <img v-lazy="coverImg" class="img-cover" />
    </div>
    <i @click="handleDelFile" class="icon-del"></i>
    <div class="progress-wrapper" v-show="uploading">
      <div class="progress-bar">
        <div class="active-bar" :style="{ transform: `scaleX(${uploadProgress})` }"></div>
      </div>
      <span class="progress-text">上传中</span>
    </div>
    <div class="reupload-wrapper" @click="handleReupload" v-show="showReupload">
      <i class="icon-reupload"></i>
      <span class="reupload-text">重新上传</span>
    </div>
    <div class="icon icon-play" @click="handlePreview" v-if="fileInfo.fileType === 'video'"></div>
  </div>
</template>

<script>
import { uploadImg, uploadVideoChunk, mergeVideo } from "../../server/interfaces.js"
import { CancelToken } from "../../server/http"
import { resolveFile, fileChunkMd5 } from "./utils/upload"
import { mapMutations } from "vuex"

const REUPLOAD_COUNT = 1
const UPLOAD_ERR_MSG = "上传失败，请稍后重试"

export default {
  name: "uiFileItem",
  props: {
    fileInfo: {
      type: Object,
      default() {
        return {
          file: null,
          fileName: "",
          fileSize: "",
          fileType: "",
          cover: "",
          mediaId: "",
          key: ""
        }
      }
    },
    fileIndex: {
      type: [Number, String],
      default: ""
    }
  },
  data() {
    return {
      uploadProgress: 0,
      uploadFail: false,
      uploading: false,
      showReupload: false,
      cancelUploadFunc: null,
      defaultPoster: require("./images/default_poster.jpg"),
      uploadChunkOptions: {
        currentIndex: 0,
        totalChunk: 0,
        uploadIndexs: [],
        status: "",
        cancelFunc: []
      },
      fileInfoChunk: {
        file: null,
        fileName: "",
        fileSize: "",
        fileType: "",
        cover: "",
        mediaId: "",
        key: ""
      }
    }
  },
  methods: {
    ...mapMutations({
      showToast: "toast/showToast"
    }),
    finishUpload() {
      this.uploadProgress = 1
      let timer = window.setTimeout(() => {
        this.uploading = false
        window.clearTimeout(timer)
        timer = null
      }, 300)
    },
    async _handleUploadVideo() {
      if (this.fileInfo.mediaId) return
      !this.fileInfoChunk.identifier && (this.fileInfoChunk = await resolveFile(this.fileInfo))
      this.uploadChunkOptions.totalChunk = this.fileInfoChunk.fileChunks.length
      this.uploadChunkOptions.uploadIndexs = this.uploadChunkOptions.uploadIndexs.length
        ? this.uploadChunkOptions.uploadIndexs
        : this.mergeVideo
        ? []
        : Object.keys(new Array(this.uploadChunkOptions.totalChunk).fill(""))
      this._handleUploadChunk()
      // @TODO上传视频
    },
    _handleUploadChunk() {
      const chunkArr = this.uploadChunkOptions.uploadIndexs.slice(0)
      const totalChunk = this.fileInfoChunk.fileChunks.length
      const total = chunkArr.length
      const hasUploadChunkCount = totalChunk - total
      const startTime = new Date().getTime()
      let progress = 0
      let failCount = 0
      const completeUpload = ({ status } = {}) => {
        const complete = progress === total
        if (complete) {
          if (this.uploadChunkOptions.uploadIndexs.length === 0) {
            // console.log("取消上传就合并")
            status === "success" && this._handleMergeChunk()
            window.console.log(`上传完成 -> 用时：${new Date().getTime() - startTime} ms`)
          } else {
            this.handleUploadFail()
          }
        }
      }
      const updateProgress = () => {
        this.uploadProgress = ((0.9 * (progress + hasUploadChunkCount)) / totalChunk).toFixed(2)
      }
      updateProgress()
      if (chunkArr.length === 0 && this.fileInfoChunk.identifier && this.fileInfo.file.size) {
        this._handleMergeChunk()
        return
      }
      // 测试
      this.totalB = new Date().getTime()
      // console.log("开始上传", new Date())
      const startIndex = 0
      const lastIndex = this.uploadChunkOptions.uploadIndexs.length - 1
      let currentIndex = startIndex
      let chunk = this.fileInfoChunk.fileChunks[this.uploadChunkOptions.uploadIndexs[currentIndex]]
      const _uploadVideoChunk = async chunk => {
        const file = chunk
        const md5 = this.fileInfoChunk.identifier
        const source = CancelToken.source()
        const formData = new FormData()
        let currentChunkIndex = this.uploadChunkOptions.uploadIndexs[0]
        const isLast = currentIndex === lastIndex
        let chunkMd5 = ""
        let lastChunk = false
        if (isLast) {
          chunkMd5 = await fileChunkMd5(file)
          lastChunk = true
        }
        formData.append("lastChunk", lastChunk)
        formData.append("file", file)
        formData.append("md5", md5)
        formData.append("chuckNum", currentChunkIndex)
        formData.append("chuckMd5", chunkMd5)
        const params = {
          params: formData,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          timeout: 30000,
          cancelToken: source.token,
          showToast: false
        }
        this.uploadChunkOptions.cancelFunc.push(source.cancel)
        // 测试代码
        // const b = new Date().getTime()
        await uploadVideoChunk(params)
          .then(res => {
            window.console.log(res)
            // console.log(`单个chunk上传耗时-${currentChunkIndex}`, new Date().getTime() - b)
            this.uploadChunkOptions.uploadIndexs.splice(0, 1)
            progress++
            failCount = 0
            updateProgress()
            completeUpload({ status: "success" })
            const isLast = currentIndex === lastIndex
            if (!isLast) {
              currentIndex++
              currentChunkIndex = this.uploadChunkOptions.uploadIndexs[0]
              chunk = this.fileInfoChunk.fileChunks[currentChunkIndex]
              _uploadVideoChunk(chunk)
            }
          })
          .catch(err => {
            failCount++
            if (failCount > REUPLOAD_COUNT) {
              this.showToast(UPLOAD_ERR_MSG)
              this.handleUploadFail()
            } else {
              _uploadVideoChunk(chunk)
            }
            window.console.error(err)
            // console.log(`单个chunk上传耗时-${currentChunkIndex}`, new Date().getTime() - b)
          })
      }
      _uploadVideoChunk(chunk)
    },
    async _handleMergeChunk() {
      const params = new FormData()
      params.append("fileMd5", this.fileInfoChunk.identifier)
      params.append("fileExt", this.fileInfoChunk.fileExt)
      params.append("totalNum", this.fileInfoChunk.fileChunks.length)
      try {
        this.mergeVideo = true
        const mergeResult = await mergeVideo({ params, showToast: false })
        if (mergeResult) {
          this.mergeVideo = false
          this.finishUpload()
          const newFileInfo = {
            ...this.fileInfoChunk,
            ...mergeResult,
            mdFive: this.fileInfoChunk.identifier,
            fileFormat: this.fileInfoChunk.fileExt
          }
          this.$emit("updateFileList", { fileIndex: this.fileIndex, fileInfo: newFileInfo })
          // console.log("结束上传时间", new Date().getTime() - this.totalB)
        }
      } catch (err) {
        window.console.error(err)
        this.showToast(UPLOAD_ERR_MSG)
        this.handleUploadFail()
      }
    },
    async _handleUploadFile() {
      if (this.fileInfo.mediaId) return
      const uploadProgress = ({ loaded, total }) => {
        this.uploadProgress = ((0.9 * loaded) / total).toFixed(2)
      }
      const source = CancelToken.source()
      this.cancelUploadFunc = source.cancel
      const formData = new FormData()
      formData.append("file", this.fileInfo.file)
      const params = {
        params: formData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        timeout: 30000,
        onUploadProgress: uploadProgress,
        cancelToken: source.token
      }
      try {
        this.showReupload = false
        this.uploading = true
        switch (this.fileInfo.fileType) {
          case "image":
            await this.handleUploadImg(params)
            break
          case "video":
            await this._handleUploadVideo()
            break
        }
      } catch (err) {
        this.uploading = false
        window.console.error(err)
        this.handleUploadFail()
      }
    },
    async handleUploadImg(params) {
      try {
        const mediaId = await uploadImg(params)
        this.finishUpload()
        const newFileInfo = {
          ...this.fileInfo,
          mediaId: mediaId
        }
        this.$emit("updateFileList", { fileIndex: this.fileIndex, fileInfo: newFileInfo })
      } catch (err) {
        throw err
      }
    },
    handleCancelUpload() {
      this.cancelUploadFunc && this.cancelUploadFunc()
      this.uploadChunkOptions.cancelFunc.forEach(cancelFunc => {
        cancelFunc()
      })
    },
    handleReupload() {
      this.uploadProgress = 0
      this.uploadFail = false
      this._handleUploadFile()
    },
    handleUploadFail() {
      this.uploadFail = true
      this.showReupload = true
      this.finishUpload()
    },
    handleDelFile() {
      if (this.uploading) {
        this.handleCancelUpload()
      }
      this.$emit("delFile", { fileIndex: this.fileIndex })
    },
    handlePreview() {
      if (this.fileInfo.fileType === "video") {
        // @TODO 跳转播放视频
      }
    },
    initUpload() {
      const hasMediaId = !!this.fileInfo.mediaId
      if (!hasMediaId && this.fileInfo.file) {
        // @TODO 有可能还要区分视频和图片，目前任务是通用的
        this._handleUploadFile()
      }
    }
  },
  computed: {
    coverImg() {
      let result = this.fileInfo.cover
      if (this.fileInfo.fileType === "video") {
        result = result || this.defaultPoster
      }
      return result
    }
  },
  created() {
    this.initUpload()
  }
}
</script>

<style lang="scss" scoped>
.ui-file-item {
  width: 1.54rem;
  height: 1.54rem;
  background: #f7f7f7;
  margin-right: 0.18rem;
  margin-bottom: 0.18rem;
  display: flex;
  justify-content: flex-start;
  flex-flow: column nowrap;
  align-items: center;
  font-size: 0.24rem;
  border-radius: 3.52px;
  position: relative;
  overflow: hidden;
  &:nth-child(4n) {
    margin-right: 0;
  }
  .upload-img {
    width: 100%;
    height: 100%;
    .img-cover {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .icon-del {
    position: absolute;
    right: 0;
    top: 0;
    background: url(../../assets/images/reportdetail_pic_icon_delete.png);
    background-size: 100%;
    display: block;
    width: 0.4rem;
    height: 0.4rem;
    z-index: 1000;
  }
  .progress-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    .progress-bar {
      margin-top: 0.5rem;
      margin-bottom: 0.25rem;
      border-radius: 0.03rem;
      background: #fff;
      width: 0.72rem;
      height: 3px;
      .active-bar {
        height: 100%;
        width: 100%;
        border-radius: 0.03rem;
        background: #f64e45;
        transform-origin: 0 0;
        transition: all 0.3s;
        transform: scaleX(0);
      }
    }
    .progress-text {
      font-size: 0.22rem;
      color: #fff;
    }
  }
  .reupload-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    .icon-reupload {
      width: 0.35rem;
      height: 0.35rem;
      background: url(../../assets/images/reportpage_icon_reupload.png) no-repeat center;
      background-size: 100%;
      margin-bottom: 0.15rem;
      margin-top: 0.5rem;
    }
    .reupload-text {
      text-align: center;
      font-size: 0.22rem;
      color: #fff;
    }
  }
  .icon-play {
    display: inline-block;
    width: 0.44rem;
    height: 0.44rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    background: url("../../assets/images/icon_vedio.png") no-repeat center;
    background-size: 100%;
  }
}
</style>
